import {
  MapPin,
  Layout,
  Layers,
  GitBranch,
  Target,
  Zap,
  Trophy,
  BookOpen,
  Code,
  Briefcase,
  Rocket,
  Star,
  Heart,
  Lightbulb,
  Music,
  Camera,
  Palette,
  Globe,
  Coffee,
  Gamepad2,
  GraduationCap,
  Dumbbell,
  Utensils,
  Pencil,
  Library,
  BookMarked,
  ClipboardList,
  FolderKanban,
  Milestone,
  Flag,
  Activity,
  Calendar,
  Timer,
  Flame,
  Box,
  Puzzle,
  Component,
  SquareCode,
  Network,
  Cpu,
  Server,
  Database,
  Binary,
  Folder,
  FolderOpen,
  Package,
  Brain,
  Workflow,
  Terminal,
  Bug,
  GitPullRequest,
  FileCode,
  Laptop,
  Monitor,
  Smartphone,
  Tablet,
  Watch,
  Headphones,
  Speaker,
  Tv,
  Cloud,
  Share2,
  Link,
  Mail,
  MessageSquare,
  Phone,
  Video,
  Image,
  Film,
  Mic,
  Crown,
  Award,
  Medal,
  Sparkles,
  Mountain,
  Trees,
  Apple,
  Cherry,
  Carrot,
  Salad,
  Pizza,
  Sandwich,
  IceCream,
  CakeSlice,
  Wine,
  Beer,
  Martini,
  Car,
  Bike,
  Train,
  Plane,
  Ship,
  Compass,
  Map,
  Navigation,
  Home,
  Building,
  Building2,
  CreditCard,
  Wallet,
  PiggyBank,
  Banknote,
  Coins,
  TrendingUp,
  BarChart,
  PieChart,
  Calculator,
  Receipt,
  FileSpreadsheet,
  Presentation,
  Users,
  UserCheck,
  PersonStanding,
  Stethoscope,
  Pill,
  HeartPulse,
  BrainCircuit,
  Eye,
  Footprints,
  Scissors,
  Brush,
  PenTool,
  List,
  CheckSquare,
  ClipboardCheck,
  NotebookPen,
  BookText,
  ScrollText,
  Newspaper,
  Rss,
  Podcast,
  Clapperboard,
  Drama,
  Joystick,
  Shield,
  Gem,
  Key,
  Lock,
  Unlock,
  ShieldCheck,
  Settings,
  Wrench,
  Hammer,
  Ruler,
  Scale,
  Gauge,
  Microscope,
  Telescope,
  Scan,
  Fingerprint,
  type LucideIcon,
} from 'lucide-react';
import type { IconCategory, TrackCategory, DifficultyLevel, PriorityLevel } from './types';

// Icon categories for track icon picker
export const iconCategories: IconCategory[] = [
  {
    name: 'Learning & Education',
    icons: [
      { id: 'book-open', icon: BookOpen, label: 'Book' },
      { id: 'graduation-cap', icon: GraduationCap, label: 'Education' },
      { id: 'library', icon: Library, label: 'Library' },
      { id: 'book-marked', icon: BookMarked, label: 'Bookmark' },
      { id: 'book-text', icon: BookText, label: 'Text Book' },
      { id: 'notebook-pen', icon: NotebookPen, label: 'Notebook' },
      { id: 'scroll-text', icon: ScrollText, label: 'Scroll' },
      { id: 'brain', icon: Brain, label: 'Brain' },
      { id: 'brain-circuit', icon: BrainCircuit, label: 'AI Brain' },
      { id: 'lightbulb', icon: Lightbulb, label: 'Ideas' },
      { id: 'microscope', icon: Microscope, label: 'Science' },
      { id: 'telescope', icon: Telescope, label: 'Astronomy' },
    ],
  },
  {
    name: 'Coding & Tech',
    icons: [
      { id: 'code', icon: Code, label: 'Code' },
      { id: 'terminal', icon: Terminal, label: 'Terminal' },
      { id: 'file-code', icon: FileCode, label: 'File Code' },
      { id: 'square-code', icon: SquareCode, label: 'Code Block' },
      { id: 'bug', icon: Bug, label: 'Bug' },
      { id: 'git-branch', icon: GitBranch, label: 'Git Branch' },
      { id: 'git-pull-request', icon: GitPullRequest, label: 'Pull Request' },
      { id: 'cpu', icon: Cpu, label: 'CPU' },
      { id: 'server', icon: Server, label: 'Server' },
      { id: 'database', icon: Database, label: 'Database' },
      { id: 'network', icon: Network, label: 'Network' },
      { id: 'cloud', icon: Cloud, label: 'Cloud' },
      { id: 'binary', icon: Binary, label: 'Binary' },
      { id: 'workflow', icon: Workflow, label: 'Workflow' },
    ],
  },
  {
    name: 'Devices',
    icons: [
      { id: 'laptop', icon: Laptop, label: 'Laptop' },
      { id: 'monitor', icon: Monitor, label: 'Monitor' },
      { id: 'smartphone', icon: Smartphone, label: 'Phone' },
      { id: 'tablet', icon: Tablet, label: 'Tablet' },
      { id: 'watch', icon: Watch, label: 'Watch' },
      { id: 'headphones', icon: Headphones, label: 'Headphones' },
      { id: 'speaker', icon: Speaker, label: 'Speaker' },
      { id: 'tv', icon: Tv, label: 'TV' },
      { id: 'gamepad-2', icon: Gamepad2, label: 'Gaming' },
      { id: 'joystick', icon: Joystick, label: 'Joystick' },
    ],
  },
  {
    name: 'Work & Business',
    icons: [
      { id: 'briefcase', icon: Briefcase, label: 'Work' },
      { id: 'building', icon: Building, label: 'Office' },
      { id: 'building-2', icon: Building2, label: 'Building' },
      { id: 'presentation', icon: Presentation, label: 'Present' },
      { id: 'file-spreadsheet', icon: FileSpreadsheet, label: 'Spreadsheet' },
      { id: 'clipboard-list', icon: ClipboardList, label: 'Checklist' },
      { id: 'clipboard-check', icon: ClipboardCheck, label: 'Done' },
      { id: 'folder-kanban', icon: FolderKanban, label: 'Kanban' },
      { id: 'users', icon: Users, label: 'Team' },
      { id: 'user-check', icon: UserCheck, label: 'Verified' },
    ],
  },
  {
    name: 'Finance',
    icons: [
      { id: 'wallet', icon: Wallet, label: 'Wallet' },
      { id: 'credit-card', icon: CreditCard, label: 'Card' },
      { id: 'banknote', icon: Banknote, label: 'Money' },
      { id: 'coins', icon: Coins, label: 'Coins' },
      { id: 'piggy-bank', icon: PiggyBank, label: 'Savings' },
      { id: 'trending-up', icon: TrendingUp, label: 'Growth' },
      { id: 'bar-chart', icon: BarChart, label: 'Chart' },
      { id: 'pie-chart', icon: PieChart, label: 'Pie Chart' },
      { id: 'calculator', icon: Calculator, label: 'Calculator' },
      { id: 'receipt', icon: Receipt, label: 'Receipt' },
    ],
  },
  {
    name: 'Goals & Progress',
    icons: [
      { id: 'target', icon: Target, label: 'Target' },
      { id: 'flag', icon: Flag, label: 'Flag' },
      { id: 'milestone', icon: Milestone, label: 'Milestone' },
      { id: 'rocket', icon: Rocket, label: 'Launch' },
      { id: 'star', icon: Star, label: 'Star' },
      { id: 'trophy', icon: Trophy, label: 'Trophy' },
      { id: 'award', icon: Award, label: 'Award' },
      { id: 'medal', icon: Medal, label: 'Medal' },
      { id: 'crown', icon: Crown, label: 'Crown' },
      { id: 'gem', icon: Gem, label: 'Gem' },
      { id: 'sparkles', icon: Sparkles, label: 'Sparkles' },
      { id: 'zap', icon: Zap, label: 'Energy' },
    ],
  },
  {
    name: 'Health & Fitness',
    icons: [
      { id: 'heart', icon: Heart, label: 'Heart' },
      { id: 'heart-pulse', icon: HeartPulse, label: 'Pulse' },
      { id: 'dumbbell', icon: Dumbbell, label: 'Fitness' },
      { id: 'activity', icon: Activity, label: 'Activity' },
      { id: 'flame', icon: Flame, label: 'Calories' },
      { id: 'footprints', icon: Footprints, label: 'Steps' },
      { id: 'bike', icon: Bike, label: 'Cycling' },
      { id: 'person-standing', icon: PersonStanding, label: 'Standing' },
      { id: 'stethoscope', icon: Stethoscope, label: 'Health' },
      { id: 'pill', icon: Pill, label: 'Medicine' },
      { id: 'apple', icon: Apple, label: 'Nutrition' },
      { id: 'salad', icon: Salad, label: 'Diet' },
    ],
  },
  {
    name: 'Food & Drinks',
    icons: [
      { id: 'utensils', icon: Utensils, label: 'Dining' },
      { id: 'pizza', icon: Pizza, label: 'Pizza' },
      { id: 'sandwich', icon: Sandwich, label: 'Sandwich' },
      { id: 'cake-slice', icon: CakeSlice, label: 'Dessert' },
      { id: 'ice-cream', icon: IceCream, label: 'Ice Cream' },
      { id: 'coffee', icon: Coffee, label: 'Coffee' },
      { id: 'wine', icon: Wine, label: 'Wine' },
      { id: 'beer', icon: Beer, label: 'Beer' },
      { id: 'martini', icon: Martini, label: 'Cocktail' },
      { id: 'cherry', icon: Cherry, label: 'Fruits' },
      { id: 'carrot', icon: Carrot, label: 'Veggies' },
    ],
  },
  {
    name: 'Creative & Arts',
    icons: [
      { id: 'palette', icon: Palette, label: 'Art' },
      { id: 'brush', icon: Brush, label: 'Brush' },
      { id: 'pen-tool', icon: PenTool, label: 'Design' },
      { id: 'pencil', icon: Pencil, label: 'Draw' },
      { id: 'camera', icon: Camera, label: 'Photo' },
      { id: 'image', icon: Image, label: 'Image' },
      { id: 'film', icon: Film, label: 'Film' },
      { id: 'video', icon: Video, label: 'Video' },
      { id: 'music', icon: Music, label: 'Music' },
      { id: 'mic', icon: Mic, label: 'Audio' },
      { id: 'clapperboard', icon: Clapperboard, label: 'Cinema' },
      { id: 'drama', icon: Drama, label: 'Theater' },
    ],
  },
  {
    name: 'Travel & Places',
    icons: [
      { id: 'globe', icon: Globe, label: 'World' },
      { id: 'map', icon: Map, label: 'Map' },
      { id: 'map-pin', icon: MapPin, label: 'Location' },
      { id: 'compass', icon: Compass, label: 'Compass' },
      { id: 'navigation', icon: Navigation, label: 'Navigate' },
      { id: 'plane', icon: Plane, label: 'Flight' },
      { id: 'car', icon: Car, label: 'Drive' },
      { id: 'train', icon: Train, label: 'Train' },
      { id: 'ship', icon: Ship, label: 'Cruise' },
      { id: 'mountain', icon: Mountain, label: 'Hiking' },
      { id: 'trees', icon: Trees, label: 'Nature' },
      { id: 'home', icon: Home, label: 'Home' },
    ],
  },
  {
    name: 'Communication',
    icons: [
      { id: 'mail', icon: Mail, label: 'Email' },
      { id: 'message-square', icon: MessageSquare, label: 'Chat' },
      { id: 'phone', icon: Phone, label: 'Call' },
      { id: 'share-2', icon: Share2, label: 'Share' },
      { id: 'link', icon: Link, label: 'Link' },
      { id: 'rss', icon: Rss, label: 'RSS' },
      { id: 'newspaper', icon: Newspaper, label: 'News' },
      { id: 'podcast', icon: Podcast, label: 'Podcast' },
    ],
  },
  {
    name: 'Organization',
    icons: [
      { id: 'folder', icon: Folder, label: 'Folder' },
      { id: 'folder-open', icon: FolderOpen, label: 'Open' },
      { id: 'package', icon: Package, label: 'Package' },
      { id: 'box', icon: Box, label: 'Box' },
      { id: 'layers', icon: Layers, label: 'Layers' },
      { id: 'layout', icon: Layout, label: 'Layout' },
      { id: 'component', icon: Component, label: 'Component' },
      { id: 'puzzle', icon: Puzzle, label: 'Puzzle' },
      { id: 'calendar', icon: Calendar, label: 'Calendar' },
      { id: 'timer', icon: Timer, label: 'Timer' },
      { id: 'list', icon: List, label: 'List' },
      { id: 'check-square', icon: CheckSquare, label: 'Todo' },
    ],
  },
  {
    name: 'Security',
    icons: [
      { id: 'lock', icon: Lock, label: 'Lock' },
      { id: 'unlock', icon: Unlock, label: 'Unlock' },
      { id: 'key', icon: Key, label: 'Key' },
      { id: 'shield', icon: Shield, label: 'Shield' },
      { id: 'shield-check', icon: ShieldCheck, label: 'Secure' },
      { id: 'fingerprint', icon: Fingerprint, label: 'Fingerprint' },
      { id: 'scan', icon: Scan, label: 'Scan' },
      { id: 'eye', icon: Eye, label: 'View' },
    ],
  },
  {
    name: 'Tools',
    icons: [
      { id: 'settings', icon: Settings, label: 'Settings' },
      { id: 'wrench', icon: Wrench, label: 'Wrench' },
      { id: 'hammer', icon: Hammer, label: 'Hammer' },
      { id: 'ruler', icon: Ruler, label: 'Ruler' },
      { id: 'scale', icon: Scale, label: 'Scale' },
      { id: 'gauge', icon: Gauge, label: 'Gauge' },
      { id: 'scissors', icon: Scissors, label: 'Cut' },
    ],
  },
];

// Flattened icon lookup array
export const trackIcons = iconCategories.flatMap(cat => cat.icons);

// Get icon component by id
export function getTrackIcon(iconId?: string): LucideIcon {
  const found = trackIcons.find((i) => i.id === iconId);
  return found?.icon || MapPin;
}

// Track color options
export const trackColors = [
  // Reds & Pinks
  { id: 'red', value: '#ef4444', label: 'Red' },
  { id: 'rose', value: '#f43f5e', label: 'Rose' },
  { id: 'pink', value: '#ec4899', label: 'Pink' },
  { id: 'fuchsia', value: '#d946ef', label: 'Fuchsia' },
  // Purples
  { id: 'purple', value: '#a855f7', label: 'Purple' },
  { id: 'violet', value: '#8b5cf6', label: 'Violet' },
  { id: 'indigo', value: '#6366f1', label: 'Indigo' },
  // Blues
  { id: 'blue', value: '#3b82f6', label: 'Blue' },
  { id: 'sky', value: '#0ea5e9', label: 'Sky' },
  { id: 'cyan', value: '#06b6d4', label: 'Cyan' },
  // Teals & Greens
  { id: 'teal', value: '#14b8a6', label: 'Teal' },
  { id: 'emerald', value: '#10b981', label: 'Emerald' },
  { id: 'green', value: '#22c55e', label: 'Green' },
  { id: 'lime', value: '#84cc16', label: 'Lime' },
  // Yellows & Oranges
  { id: 'yellow', value: '#eab308', label: 'Yellow' },
  { id: 'amber', value: '#f59e0b', label: 'Amber' },
  { id: 'orange', value: '#f97316', label: 'Orange' },
  // Neutrals & Special
  { id: 'stone', value: '#78716c', label: 'Stone' },
  { id: 'slate', value: '#64748b', label: 'Slate' },
  { id: 'zinc', value: '#71717a', label: 'Zinc' },
  { id: 'gray', value: '#6b7280', label: 'Gray' },
  // Dark & Rich
  { id: 'navy', value: '#1e3a5f', label: 'Navy' },
  { id: 'maroon', value: '#7f1d1d', label: 'Maroon' },
  { id: 'forest', value: '#14532d', label: 'Forest' },
  { id: 'chocolate', value: '#78350f', label: 'Chocolate' },
  { id: 'plum', value: '#581c87', label: 'Plum' },
  { id: 'midnight', value: '#312e81', label: 'Midnight' },
  { id: 'charcoal', value: '#1f2937', label: 'Charcoal' },
  { id: 'black', value: '#171717', label: 'Black' },
];

// Category naming conventions for different track types
export const categoryNaming: Record<TrackCategory, { level1: string; level2: string; level3: string; level4: string }> = {
  learning: { level1: 'Course', level2: 'Module', level3: 'Lesson', level4: 'Exercise' },
  project: { level1: 'Project', level2: 'Phase', level3: 'Sprint', level4: 'Task' },
  goals: { level1: 'Goal', level2: 'Milestone', level3: 'Objective', level4: 'Action' },
  book: { level1: 'Book', level2: 'Chapter', level3: 'Section', level4: 'Note' },
  fitness: { level1: 'Program', level2: 'Week', level3: 'Day', level4: 'Workout' },
  coding: { level1: 'Project', level2: 'Feature', level3: 'Component', level4: 'Task' },
  dsa: { level1: 'Topic', level2: 'Pattern', level3: 'Problem', level4: 'Solution' },
  'system-design': { level1: 'System', level2: 'Component', level3: 'Design', level4: 'Implementation' },
  generic: { level1: 'Category', level2: 'Group', level3: 'Subgroup', level4: 'Item' },
};

// Difficulty configuration
export const difficultyConfig: Record<DifficultyLevel, {
  label: string;
  bg: string;
  text: string;
  hover: string;
  icon: LucideIcon;
}> = {
  easy: {
    label: 'Easy',
    bg: 'bg-emerald-100 dark:bg-emerald-900/30',
    text: 'text-emerald-700 dark:text-emerald-300',
    hover: 'hover:bg-emerald-200 dark:hover:bg-emerald-800/40',
    icon: Zap,
  },
  medium: {
    label: 'Medium',
    bg: 'bg-yellow-100 dark:bg-yellow-900/30',
    text: 'text-yellow-700 dark:text-yellow-300',
    hover: 'hover:bg-yellow-200 dark:hover:bg-yellow-800/40',
    icon: Target,
  },
  hard: {
    label: 'Hard',
    bg: 'bg-red-100 dark:bg-red-900/30',
    text: 'text-red-700 dark:text-red-300',
    hover: 'hover:bg-red-200 dark:hover:bg-red-800/40',
    icon: Trophy,
  },
};

// Priority configuration - Always AMBER/ORANGE tones (light to dark)
export const priorityConfig: Record<PriorityLevel, {
  label: string;
  level: 1 | 2 | 3 | 4;
  bg: string;
  text: string;
  hover: string;
  activeColor: string;
}> = {
  low: {
    label: 'Low',
    level: 1,
    bg: '',
    text: 'text-gray-600 dark:text-gray-400',
    hover: '',
    activeColor: 'text-amber-400 dark:text-amber-400',
  },
  medium: {
    label: 'Medium',
    level: 2,
    bg: '',
    text: 'text-gray-600 dark:text-gray-400',
    hover: '',
    activeColor: 'text-amber-500 dark:text-amber-400',
  },
  high: {
    label: 'High',
    level: 3,
    bg: '',
    text: 'text-gray-600 dark:text-gray-400',
    hover: '',
    activeColor: 'text-orange-500 dark:text-orange-400',
  },
  urgent: {
    label: 'Urgent',
    level: 4,
    bg: '',
    text: 'text-gray-600 dark:text-gray-400',
    hover: '',
    activeColor: 'text-orange-600 dark:text-orange-500',
  },
};
